<div class="container flex-column" xmlns="http://www.w3.org/1999/html">
    <div class="d-flex justify-content-end mt-2">
        <img src="assets/Logo-eSPAJK.jpg" width="160" height="auto">
    </div>
    <div class="riplay-title">
        <h2 class="text-center mt-5 color-blue"><b>ELLISE Sales Dashboard</b></h2>
    </div>
</div>

<div class="container mt-5 pt-4 form-header form-content bg-white">
    <div class="bg-white form-content pb-3 align-content-center mb-4">
        <div class="px-2">
            <div class="d-flex justify-content-between flex-row">
                <p (click)="back()" class="cursor-pointer"><i class="bi bi-arrow-left"></i> Kembali</p>
            </div>

            <div class="bg-white p-2 form-content">
                <p class="title-input m-0 color-gray">Kantor Cabang Proses Kredit Lama</p>
                <h4 class="title-input mt-0 color-gray">{{ this.dataDashboard.branchDescription }}</h4>


                <form [formGroup]="formEndorse" (ngSubmit)="continue()" #form="ngForm">

                    <div class="d-flex flex-column mb-2"
                        [ngClass]="{'text-danger' : (formEndorse.controls['areaKantorCabang'].dirty || form.submitted) && !formEndorse.controls['areaKantorCabang'].valid}">
                        <p class="title-input m-0">Area Kantor Cabang</p>
                        <select class="bottom-border" formControlName="areaKantorCabang"
                            (change)="onSelectionBranchAreaChange($event)">
                            <option *ngFor="let branchArea of branchAreaList" [value]="branchArea.region">
                                {{branchArea.region}}
                            </option>
                        </select>
                    </div>

                    <div class="d-flex flex-column mb-2"
                        [ngClass]="{'text-danger' : (formEndorse.controls['kantorCabang'].dirty || form.submitted) && !formEndorse.controls['kantorCabang'].valid}">
                        <p class="title-input m-0">Kantor Cabang</p>
                        <select class="bottom-border" formControlName="kantorCabang">
                            <option *ngFor="let branch of branchList" [value]="branch.label + '-' + branch.value">
                                {{branch.label}}
                            </option>
                        </select>
                    </div>

                    <p class="description-input text-center">Perubahan Cabang Proses Kredit hanya dapat dilakukan 1 (satu) kali.</p>

                    <div class="d-flex flex-row justify-content-center flex-gap">
                        <button class="rounded-3 btn-continue mt-3 py-3 flex-grow-1" type="submit">
                            <span *ngIf="this.isLoading" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                            Ajukan Perbaikan
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>